import { render, staticRenderFns } from "./schoolinfo-edit.vue?vue&type=template&id=f9cae1f2&scoped=true"
import script from "./schoolinfo-edit.vue?vue&type=script&lang=js"
export * from "./schoolinfo-edit.vue?vue&type=script&lang=js"
import style0 from "./schoolinfo-edit.vue?vue&type=style&index=0&id=f9cae1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cae1f2",
  null
  
)

export default component.exports